// extracted by mini-css-extract-plugin
export default {"industryModel":"styles_industryModel__JOzVF","boxModel":"styles_boxModel__32PX4","cross":"styles_cross__B5Otp"};